/*eslint-disable*/
import React from "react";
import {
    Button,
    FormGroup,
    Input,
    Form,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col
} from "reactstrap";

import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";
import AppleSignIn from "components/AppleSignIn/AppleSignIn.jsx";
import { config } from "_constants";
import { isProductionBuild } from "_helpers";

export default function AuthFormContainerXS({
    mode, // "signin" | "signup"
    setMode,
    signupEmailFocus,
    signinEmailFocus,
    signinPasswordFocus,
    email,
    username,
    password,
    handleChange,
    enterPressed,
    startEmailRegistration,
    forgotPasswordAlert,
    handleSubmit,
    responseFacebook,
    responseGoogle,
    responseApple,
    tryAppleLogIn,
    setSigninEmailFocus,
    setSignupEmailFocus,
    setSigninPasswordFocus

}) {
    const isSignIn = mode === "signin";
    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <Row className="align-items-center text-center">
            <Col xs={10} className="mx-auto" style={{ maxWidth: "300px" }}>
                <div>
                    <h1 className="livenyte-title text-primary" style={{ fontSize: "2rem" }}>
                        LiveNyte
                    </h1>

                    <h3 className="surtitle text-white">{isSignIn ? "Sign In" : "Sign Up"}</h3>
                    <div className="my-2 special-underline-lightGray" />

                    {/* SOCIAL */}
                    <div className="social-container">
                        <FacebookLogin
                            appId="197943750696053"
                            autoLoad={false}
                            fields="name,email,picture"
                            scope="public_profile"
                            redirectUri={config.serverUrl}
                            isMobile={false}
                            disableMobileRedirect={true}
                            callback={responseFacebook}
                            render={(renderProps) => (
                                <Button
                                    color="facebook"
                                    style={{ width: "35px", height: "35px", fontSize: "1.1rem" }}
                                    size="sm"
                                    onClick={renderProps.onClick}
                                >
                                    <i className="fa-brands fa-facebook"></i>
                                </Button>
                            )}
                        />

                        <GoogleLogin
                            clientId="1007593483972-gr74opa14suioe6bkvp0etop08pbfjoj.apps.googleusercontent.com"
                            onSuccess={(rsp) => responseGoogle(true, rsp)}
                            onFailure={(rsp) => responseGoogle(false, rsp)}
                            redirectUri={config.serverUrl}
                            cookiePolicy="single_host_origin"
                            render={(renderProps) => (
                                <Button
                                    color="white"
                                    size="sm"
                                    style={{ width: "35px", height: "35px" }}
                                    onClick={renderProps.onClick}
                                >
                                    <img
                                        alt="Google"
                                        style={{ width: "17px", height: "17px" }}
                                        src={require("assets/img/icons/common/google.svg").default}
                                    />
                                </Button>
                            )}
                        />

                        {isProductionBuild() && (
                            <AppleSignIn
                                config={{
                                    clientId: "com.livenyte.livenyte",
                                    redirectURI: config.serverUrl,
                                    responseType: "code",
                                    responseMode: "form_post",
                                    scope: "name email",
                                    usePopup: true,
                                }}
                                onSuccess={(rsp) => responseApple(true, rsp)}
                                onFailure={(rsp) => responseApple(false, rsp)}
                                render={(renderProps) => (
                                    <Button color="dark" size="sm" type="button" style={{ width: "35px", height: "35px" }} onClick={renderProps.onClick}>
                                        <i className="fa-brands fa-apple" style={{ fontSize: "1.15rem", top: "0.1rem", left: "0.02rem" }}></i>
                                    </Button>
                                )}
                            />
                        )}
                    </div>

                    {/* SUBTITLE */}
                    <h5 className="mb-4 pt-2 surtitle text-lighter" style={{ fontWeight: 400 }}>
                        {isSignIn ? "or with email + password" : "or with email"}
                    </h5>

                    {/* EMAIL / USERNAME */}
                    <FormGroup className={`mb-3 ${isSignIn ? signinEmailFocus : signupEmailFocus}`}>
                        <InputGroup className="exampleDarkGlassBlur">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText className="border-0"><i className="ni ni-email-83"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input
                                placeholder="Email"
                                type="email"
                                name={isSignIn ? "username" : "email"}
                                autoComplete="email"
                                className="text-white border-0 autofill-darkMode"
                                value={isSignIn ? username : email}
                                onChange={handleChange}
                                onKeyPress={enterPressed}
                                onFocus={isSignIn ? () => setSigninEmailFocus("focused-darkMode") : () => setSignupEmailFocus("focused-darkMode")}
                                onBlur={isSignIn ? () => setSigninEmailFocus("") : () => setSignupEmailFocus("")}
                            />
                        </InputGroup>
                    </FormGroup>

                    {/* PASSWORD (only for sign in) */}
                    {isSignIn && (
                        <FormGroup className={signinPasswordFocus}>
                            <InputGroup className="exampleDarkGlassBlur">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText className="border-0"><i className="ni ni-lock-circle-open"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Password"
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    className="text-white border-0 autofill-darkMode"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={handleChange}
                                    onKeyPress={enterPressed}
                                    onFocus={() => setSigninPasswordFocus("focused-darkMode")}
                                    onBlur={() => setSigninPasswordFocus()}
                                />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText
                                        className="border-0"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? (
                                            <i className="fa-regular fa-eye-slash"></i>
                                        ) : (
                                            <i className="fa-regular fa-eye"></i>
                                        )}
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>
                    )}

                    {/* SUBMIT */}
                    <Button
                        color="primary"
                        className="mt-3 bg-gradient-livenyte"
                        onClick={isSignIn ? handleSubmit : startEmailRegistration}
                    >
                        {isSignIn ? "Sign In" : "Sign Up"}
                    </Button>

                    {/* LINKS */}
                    {isSignIn ? (
                        <>
                            <p className="text-underline cursor-pointer text-white" onClick={forgotPasswordAlert}>
                                Forgot your password?
                            </p>

                            <span className="h4 text-white">
                                Don’t have an account?{" "}
                                <Button
                                    className="ml-2 "
                                    color="spc-white"
                                    size="sm"
                                    outline
                                    onClick={() => setMode("signup")}>
                                    Sign Up
                                </Button>
                            </span>
                        </>
                    ) : (
                        <h4 className="mt-4 pt-2 text-white">
                            Already have an account?{" "}
                            <Button className="ml-2 "
                                color="spc-white"
                                size="sm"
                                outline
                                onClick={() => setMode("signin")}>
                                Sign In
                            </Button>
                        </h4>
                    )}
                </div>
            </Col>

        </Row>
    );
}